<!-- <app-menu></app-menu> -->

<!-- Mới thêm -->
<div class="flex flex-column justify-content-center align-items-start">
    <button
        pButton
        pRipple
        icon="pi pi-phone"
        class="p-button-rounded p-button-info mr-2"
    ></button>
    <button
        pButton
        pRipple
        icon="pi pi-plus"
        class="bkc-button-violet p-button-rounded mr-2"
    ></button>
    <button
        pButton
        pRipple
        icon="pi pi-chart-bar"
        class="p-button-rounded p-button-info"
    ></button>
</div>
